import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { INewsletter, INewsletterState } from "./newsletterModel";
import { getAllNewsletter } from "./services/newsletter.services";

const initialState: INewsletterState = {
  loading: false,
  formLoading: false,
  error: "",
  NewsletterList: [],
  NewsletterID: null,
  FilterNewsletter: {
    Name: "",
    Email: "",
    MobileNo: "",
  },
};

const newsletterSlice = createSlice({
  name: "newsletter",
  initialState,
  reducers: {
    setNewsletterID: (state, action) => {
      state.NewsletterID = action.payload;
    },
    clearNewsletterID: (state) => {
      state.NewsletterID = initialState.NewsletterID;
    },

    setFilterNewsletter: (state, action) => {
      state.FilterNewsletter = action.payload;
    },
    clearFilterNewsletter: (state) => {
      state.FilterNewsletter = initialState.FilterNewsletter;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllNewsletter.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllNewsletter.fulfilled,
      (state, action: PayloadAction<INewsletter[]>) => {
        state.loading = false;
        state.NewsletterList = action.payload || [];
      }
    );
    builder.addCase(getAllNewsletter.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.NewsletterList = [];
    });
  },
});

export const {
  clearNewsletterID,
  setNewsletterID,
  clearFilterNewsletter,
  setFilterNewsletter,
} = newsletterSlice.actions;
export default newsletterSlice.reducer;
